import { MediaTag } from "@prisma/client";

export const REQUIRED_MEDIA_TAG_COUNT = {
  [MediaTag.DESIGN_INSPIRATION]: 3,
  [MediaTag.FRONT_YARD_HORIZONTAL]: 6,
  [MediaTag.BACK_YARD_HORIZONTAL]: 6,
  [MediaTag.LEFT_SIDE_YARD_HORIZONTAL]: 6,
  [MediaTag.RIGHT_SIDE_YARD_HORIZONTAL]: 6,
  [MediaTag.FRONT_YARD_SLOW_PAN_VIDEO]: 1,
  [MediaTag.BACK_YARD_SLOW_PAN_VIDEO]: 1,
  [MediaTag.LEFT_SIDE_YARD_SLOW_PAN_VIDEO]: 1,
  [MediaTag.RIGHT_SIDE_YARD_SLOW_PAN_VIDEO]: 1,
};
